<panel>
	<h1>{{ 'taskflow.create-taskflow' | translate }}</h1>
	<form>
		<scrollable>
			<section>
				<custom-select [label]="'taskflow.taskflow-template' | translate"
							   [placeholder]="'taskflow.taskflow-template-placeholder' | translate"
							   [selectList]="taskflowTemplatesList"
							   [(value)]="taskflow.sourceTemplateId"
							   (valueChange)="populateTaskActionList()"
							   [required]="true" />
				<custom-input [label]="'taskflow.title' | translate" [placeholder]="'taskflow.title-placeholder' | translate" [(value)]="taskflow.title" [required]="true" />

				<div><custom-select [label]="'taskflow.owner' | translate" [placeholder]="'taskflow.owner-placeholder' | translate" [selectList]="usersList" [(value)]="taskflow.owner" /></div>
				<div><date-input [label]="'taskflow.deadline' | translate" [placeholder]="'taskflow.deadline-placeholder' | translate" [(value)]="taskflow.deadline" /></div>

				<custom-input [label]="'taskflow.description' | translate" [inputType]="inputTypeEnum.Editor" [placeholder]="'taskflow.description-placeholder' | translate" [(value)]="taskflow.description" [required]="true" />
			</section>

			<h2>{{ 'taskflow.task-actions.title' | translate }}</h2>
			<list-view [emptyLabel]="'taskflow.task-actions.task-actions-list-empty-label'">
				<header>{{ 'taskflow.task-action.type' | translate }}</header>
				<header>{{ 'taskflow.task-action.assigned-to' | translate }}</header>
				<header></header>
				<row *listData="let action from actions" [highlighted]="selectedTaskAction == action" (action)="selectedTaskAction = action">
					<column>{{ 'enum.task-action-type.' + taskActionType[action.type] | translate }}</column>
					<column>{{ action.assignedToUserId | user: 'name' }}</column>
					<column align-right><icon (click)="deleteTaskAction(action)" type="trash-alt" /></column>
				</row>
			</list-view>
			<section>
				<add-task-action (createNewTaskAction)="createNewTaskAction($event)" />
			</section>
			<section>
				<h2>{{ 'taskflow.products' | translate }}</h2>
				@for (product of products; track product) {
				<label>
					<input type="checkbox" class="switch" [formControlName]="product.id" />
					{{ product.productVariant?.name }}
				</label><br />
				}
			</section>
		</scrollable>
		<section>
			<button confirm #saveButton (click)="saveTaskflow()" [active]="!taskActionBusy">{{ 'general.save' | translate }}</button>
		</section>
	</form>
</panel>
@if (selectedTaskAction) {
	<div>
		<new-task-action [taskAction]="selectedTaskAction" (taskActionBusy)="taskActionBusy = $event" />
	</div>
}
